module.exports = __webpack_public_path__ + "img/times-solid.6308a269.svg";